<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style4 mg-b-10">
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Шинэ ажилтан</router-link></li>
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Тавтай морил</router-link></li>
              <li class="breadcrumb-item active tx-14" aria-current="page">Хөтөлбөр</li>
            </ol>
          </nav>

          <div class="mg-y-30">
            <a @click="types.forEach(x => { x.expand = false; }); init();" role="button" style="min-width: 100px; display: inline-block" 
              :class="`${types.filter(x=>x.expand).length?'bg-white':'bg-primary text-white'} text-center rounded-10 pd-x-20 pd-y-10 tx-semibold`">Бүгд</a>
            <a @click="t.expand=!t.expand; init();" v-for="(t,i) in types" role="button" style="min-width: 100px; display: inline-block"  
              :class="`text-center mg-l-10 rounded-10 pd-x-20 pd-y-10 tx-semibold ${t.expand?'text-white bg-primary':'bg-white'}`">
              {{ t.title }}
            </a>
          </div>


          <div class="row">
            <div v-for="(t, ti) in tasks" class="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div @click="showVid(t)" role="button" class="bg-white rounded-20 pd-15">
                <div class="overflow-hidden w-full rounded-20 mg-b-10 pos-relative ht-200"
                :style="`background-image: url(${t.defaultAttachmentUrl}); background-size: cover; background-repeat: no-repeat`">
                </div>
                <div class="tx-semibold">{{ t.task }}</div>
                <div class="d-flex" style="color: #444">
                  <div>{{ t.d1 | moment('YYYY он MM сар') }}</div>
                  <div><feather type="more-vertical" style="height: 9px"></feather></div>
                  <div>{{ t.locTypeName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>
    <b-modal v-model="mdl.show" centered hide-footer size="lg" :title="mdl?.obj?.task">
      
      <div class="d-flex" v-if="mdl.rdy">
        <div class="w-50">
          <img :src="mdl.obj.defaultAttachmentUrl" alt="">
          <div v-html="mdl.obj.taskDesc" class="mg-t-20 bg-gray-100 rounded-10 pd-10"></div>
        </div>
        <div class="w-50 pd-l-20">
          <div class="mg-b-10">
            <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-5">Хугацаа</label>
            <p class="mg-b-0">{{ mdl.obj.d1 | moment('YYYY он MM сар') }}</p>
          </div>
          <div class="mg-b-10">
            <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-5">Байршил</label>
            <p class="mg-b-0">{{ mdl.obj.locTypeName }}</p>
          </div>
          <div class="mg-b-10">
            <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-5">Төлөв</label>
            <p class="mg-b-0">{{ getTypes(mdl.obj.locTypeIds) }}</p>
          </div>
          <div class="mg-b-10">
            <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-5">Бүртгэл хаагдах</label>
            <p class="mg-b-0">{{ mdl.obj.d2 | moment('YYYY.MM.DD-ны HH:mm') }}</p>
          </div>
          <div class="mg-t-20">
            <div v-if="mdl.obj.im !== null">
              <div class="alert alert-success">Бүртгүүлсэн</div>
            </div>
            <div v-else>
              <a v-if="mdl.isJoinable" @click="joinEvent(mdl.obj)"  class="btn btn-primary btn-block">Бүртгүүлэх</a>
              <a v-else  class="alert alert-danger" disabled>Бүртгэл хаагдсан</a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

import Masonry from "masonry-layout"

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      mdl:{
        rdy: false,
        show: false,
        obj: null,
        isJoinable: false
      },
      types: [],
      curId: 0,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      tasks: []
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.initTags();
    this.init();
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    joinEvent(n){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskInUser/ShareUserToTask" },
        data: { 
          taskId: n.id, 
          userId: this.$store.state.user.userId
        },
        store: this.$store,
      }).then((res) => {  
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          Notification.success({
            title: 'Амжилттай',
            message: 'Бүртгүүлсэн'
          });
          this.mdl.show= false;
        } 
      });
    },
    showVid(n){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/TaskInheritedDetail" },
        params: { id: n.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          console.log('res', res);
          this.mdl.obj= res.data.task;
          this.mdl.rdy= true;


          request({
            api: { method: "GET", url: "servertime" },
            store: this.$store,
          }).then((res) => {
            if(res!=false){
              // console.log('res servertime', res.data.now);
              this.mdl.isJoinable= moment(res.data.now).isBefore(moment(this.mdl.obj.d2));
              this.mdl.show= true;
            }
          });
        }
      });
      
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      this.tasks= [];
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 613
      );
      if (proj.length) {
        _pid = proj[0].id;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            projectId: _pid,
            skip: 0,
            size: 200,
            model: {
              isPublic: true,
              locTypeIds: this.types.filter(x=>x.expand).map(type => type.id)
            },
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            console.log('res.data', res.data);
            this.tasks= res.data.tasks;
          }
        });
      }
    },
    initTags(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Type/getTreeData" },
        params: { key: 'buddy_eventTag' },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.types= res.data.types;
        }
      });
    },
    getTypes(ids){
      return this.types.filter(x=>ids.includes(x.id)).map(x=>x.title).join(', ');
    }
  },
};
</script>